<div class="invalid-controls-wrapper">
  <p class="tw-mt-0 tw-mb-1">
    <ui-svg-icon [name]="iconNames.AlertWarning" class="tw-p-2 tw-align-middle"></ui-svg-icon>
    <span class="tw-font-strong">{{ 'common.validation.validationErrorList.title' | translate }}</span>
  </p>
  <div class="tw-pl-10">
    {{ 'common.validation.validationErrorList.list' | translate }}
    <ul>
      <ng-container *ngFor="let control of invalidControls">
        <li *ngIf="isString(control)">
          {{ 'common.field.' + control | translate }}
        </li>

        <ng-container *ngIf="isItemArray(control) && control.length">
          <br />
          <span class="sub-title">{{ 'common.field.transportOrder' | translate }} #{{ arrayIndex }}</span>
          <ng-container *ngFor="let item of control">
            <li>{{ 'common.field.' + item | translate }}</li>
          </ng-container>
        </ng-container>
      </ng-container>
    </ul>
  </div>
</div>
